module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAANhJREFUOE9jZKAyYKSyeQwj1cBypbu6f/7838HIyFja81B5GSnhWqJw3//fv79TWZiYQ7oeKJ4Ah2Gx2jOR/z+/n2X4zyDNxMgQR6yhYMP+/13NwMD4joWV3aTrjswTeKRUyD1U+s3w+8B/BkYpYgxFMYyB2bHrocJ1kONQYplYQ3EZhmEgSICQofgMw2ogPkMJGYbTQGyGMjAyfYVHAFKYoacIvDkF2fsMjP//gWMTj2F4XQizGW4oIyMbIcOIMhDm/X+M/9lhSQNfwh+phQMphQEhtVQPQwD0to0V3BZlDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moredown.png
// module id = 7wFi
// module chunks = 1